import script from "./DateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=js"

import "./DateInput.vue?vue&type=style&index=0&id=2d940912&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d940912"]])

export default __exports__